import React, { useContext, useMemo } from 'react';
import { View } from '@shared/components/View';
import { MBHover } from '@shared/components/hover';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';

export interface PressableTextRowProps {
  text: string;
  leftIcon: MBIconV2Name | null;
  rightIcon: MBIconV2Name | null;
  enabled: boolean;
  onPress?: (node: React.Component) => any;
}

export function PressableTextRow({ ...props }: PressableTextRowProps) {
  const colors = useContext(ColorThemeContext);
  const textColor = useMemo(() => {
    if (props.enabled) {
      return colors.foregroundActive;
    } else {
      return colors.foregroundInactive;
    }
  }, [props.enabled, colors]);

  return (
    <MBTouchableOpacity onPress={props.onPress} disabled={!props.enabled}>
      <MBHover
        hoverStyle={props.enabled && { backgroundColor: colors.input.backgroundInactive }}
        centerVertically
      >
        <View row centerVertically paddingVertical={1} paddingHorizontal={3}>
          {props.leftIcon != null && (
            <MBIconV2 name={props.leftIcon} color={textColor} size={grid(3)} />
          )}
          <View fill centerVertically paddingLeft={1}>
            <MBTextBody1 color={textColor}>{props.text}</MBTextBody1>
          </View>
          {props.rightIcon != null && (
            <MBIconV2 name={props.rightIcon} color={textColor} size={grid(3)} />
          )}
        </View>
      </MBHover>
    </MBTouchableOpacity>
  );
}
